import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import vuexStore from '@/vuex-store';
import initApp from '@/init';
import { createPinia } from 'pinia';
// plugin
// import pluginGlobalMixin from '@/plugins/globalMixin';
import plguinSlackWekHook from '@/plugins/slackWebHook';
import pluginVuetify from '@/plugins/vuetify';
import pluginVueDatepicker, { componentGlobalConfig } from '@/plugins/vueDatepicker';
import pluginGlobal from '@/plugins/global';
import { resetStore } from '@/plugins/piniaReset';
import pluginVChart from '@/plugins/vChart';
// Directive
import pluginCommonDirective from '@/directive/commonDirective';
import resizerX from '@/directive/resizerX';
// lib
import libGtm from '@/lib/gtm';
import vue18n from '@/locales';
import '@/lib/error-handler';
// pinia
import { initPStore, pStore, } from './pinia';
// style
import '@/styles/global.scss';
window.HCR_VERSION = process.env.VUE_APP_VERSION;
// node process env 데이터 global 변수로 활용
const parseProcessEnv = () => {
    const envData = {};
    Object.entries(process.env).forEach(([key, value,]) => {
        envData[key] = value;
    });
    return envData;
};
const pinia = createPinia();
pinia.use(resetStore);
export const app = createApp(App);
// initCustomConsoleLog();
const main = async () => {
    await initApp({
        vueCreated: false,
        // isMobile,
    });
    // Plugin
    app.use(vue18n);
    app.use(pluginVuetify);
    app.use(vuexStore);
    app.use(pinia);
    app.use(router);
    app.use(pluginCommonDirective);
    app.use(plguinSlackWekHook);
    app.use(pluginGlobal);
    app.use(pluginVueDatepicker, componentGlobalConfig);
    app.use(pluginVChart);
    // app.use(pluginGlobalMixin);
    // Directive
    app.directive('resizerX', resizerX);
    initPStore();
    if (window.Cypress) {
        window.v = app;
        window.pStore = pStore;
    }
    if (!window.Cypress) {
        app.use(libGtm);
    }
    app.config.globalProperties.$brgGlobal = parseProcessEnv();
    app.mount('#app');
};
main();
